import { render, staticRenderFns } from "./TagsDropdown.vue?vue&type=template&id=7ac52ed4&"
import script from "./TagsDropdown.vue?vue&type=script&lang=js&"
export * from "./TagsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports